import { useEffect, useState } from 'react'
import { useIsAuthenticated } from "@azure/msal-react";
import {Outlet} from 'react-router'
import './layout.css'
import Header from './Header'
import { useMsal } from "@azure/msal-react";
import { LayoutConfig } from './config/LayoutConfig'
import { AuthorizationService } from '../../services/AuthorizationService';

function Layout() {

    const { accounts } = useMsal();   
    const isAuthenticated = useIsAuthenticated();

    // CONSTANTS
    const APP_NAME = 'LST'
    const USER_NAME = isAuthenticated ? accounts[0] && accounts[0].name : '';
    
    const [menuItems, setMenuItems] = useState();
    const [userPermissions, setUserPermissions] = useState({ isAdmin: false, isSubmitter: false, isViewer: false });
    
    const getMenuItems = () => {
        // Fetch menu items that belong to user
        const menuItems = LayoutConfig.menuItems
        setMenuItems(menuItems)
    }

    const getUserPermission = () => {
        var permissions = {
            isAdmin: AuthorizationService.IsAdmin(accounts[0]), isSubmitter: AuthorizationService.IsSubmitter(accounts[0]), isViewer: AuthorizationService.IsViewer(accounts[0])
        }
        setUserPermissions(permissions);
    }
    
    // This useEffect will be run once at the beginning
    useEffect(() => {
        getMenuItems();
        getUserPermission();
    }, [])

    return (
        <div className='layout'>
            <Header appName={APP_NAME} userName={USER_NAME} menuItems={menuItems} userPermissions={userPermissions} />
            <div className='px-4'>
                <Outlet/>
            </div>
            <p className='footer'>&#169; Developed & Supported by Codebusters / RF Development and Support - External Reporting  2023 - {(new Date()).getFullYear()}, for internal use only.</p>
        </div>
    )
}

export default Layout